import { render, staticRenderFns } from "./PreviewFlashSaleTimer.vue?vue&type=template&id=6016a87a&scoped=true&"
import script from "./PreviewFlashSaleTimer.vue?vue&type=script&lang=js&"
export * from "./PreviewFlashSaleTimer.vue?vue&type=script&lang=js&"
import style0 from "./PreviewFlashSaleTimer.vue?vue&type=style&index=0&id=6016a87a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6016a87a",
  null
  
)

export default component.exports